<template>
	<v-row>
		<v-col :key='index' xs='12' md='6' lg='4' v-for='(service, index) in services'>
			<Service @click='$emit("show-service", index)' v-bind='service' />
		</v-col>
	</v-row>
</template>

<script>
import Service from './n-items/ServiceItem'
export default {
	props: ['services'],
	components: {
		Service,
	},
	data() {
		return {
			isCollapsed: true,
		}
	},
}
</script>
<style lang="scss" scoped>
</style>